import Tag from '..'

import isEmpty from 'lodash/isEmpty'
import slice from 'lodash/slice'

import styles from './index.module.css'

interface Props {
  first?: number
  tags?: string[] | null
}

const List = ({ first, tags }: Props) => {
  if (!Boolean(tags) || isEmpty(tags)) {
    return null
  }

  return (
    <div className={styles.list}>
      {slice(tags, 0, first || tags.length).map((tag) => (
        <Tag key={`tag_${tag}`} value={tag} />
      ))}
    </div>
  )
}

export default List
